import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TranslateMessage from "./translateMessage";
import { connect } from "react-redux";
import { messageAi } from "actions/aiActions";

const MessageContent = ({ data, showTrans = true, messageAi, setLoading, setImage }) => {
    const [messageTrans, setMessageTrans] = useState({});
    const { t } = useTranslation();
    try {
        let product = data?.product;
        const mess = JSON.parse(data?.content);
        const handleTranslate = async (id, text) => {
            setLoading(true);
            const data = await messageAi(text);
            if (data) setMessageTrans((prev) => ({ ...prev, [id]: data }));
            setLoading(false);
        };

        if (data.type === "IMAGE" && mess?.url)
            return (
                <img
                    className="al-cursor-pointer"
                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                    alt="message"
                    src={mess?.url}
                    onClick={() => setImage(mess?.url)}
                />
            );

        if (mess.order_id) {
            if (mess.order)
                return (
                    <span className="btn btn-light btn-sm">
                        <p>Order Id: 123123</p>
                        <p>Items: {mess.order?.line_items?.length}</p>
                        <span>Payment: {`${mess?.order?.payment.total_amount} ${mess?.order?.payment.currency}`}</span>
                    </span>
                );

            return (
                <span className="btn btn-light btn-sm">
                    Order id {data.type === "RETURN_REFUND_CARD" && "Refund"}: ({mess.order_id})
                </span>
            );
        }

        if (mess.product_id) {
            if (product) {
                return (
                    <div className="bg-white p-2 rounded border mb-2 p-2 text-start">
                        <div className="d-flex align-items-center gap-4">
                            <div style={{ minWidth: 60, height: 60, backgroundColor: "#ddd" }}>
                                <img
                                    src={product.main_images?.[0]}
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                            </div>
                            <div>
                                <span title={product.title} className="ellipsis">
                                    {product.title}
                                </span>
                                <div>
                                    <span role="button" className="text-decoration-none text-primary small">
                                        {`${product.price} $`}
                                    </span>
                                    <div className="mt-4 d-flex gap-4">
                                        <Link
                                            to={"https://shop.tiktok.com/view/product/" + product.apiProductId}
                                            className="btn btn-light btn-sm"
                                            target="_blank"
                                        >
                                            View Detail
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }

            return (
                <Link
                    to={"https://shop.tiktok.com/view/product/" + mess.product_id}
                    className="btn btn-light btn-sm"
                    target="_blank"
                >
                    View Detail Product ({mess.product_id})
                </Link>
            );
        }

        if (data.type === "VIDEO" && mess?.url) {
            return (
                <video width="300" controls>
                    <source src={mess?.url} type="video/mp4" />
                </video>
            );
        }

        return (
            <div>
                {mess.content}
                {showTrans && (
                    <>
                        <span
                            role="button"
                            onClick={(e) => handleTranslate(data.messages_tiktok_id, mess.content)}
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content={t("Translate")}
                        >
                            <i className="ki-duotone ki-messages ms-2 fs-2" aria-hidden="true">
                                <span className="path1"></span>
                                <span className="path2"></span>
                                <span className="path3"></span>
                                <span className="path4"></span>
                                <span className="path5"></span>
                            </i>
                        </span>
                        <TranslateMessage data={messageTrans?.[data.messages_tiktok_id]} />
                    </>
                )}
            </div>
        );
    } catch {
        return "";
    }
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    messageAi,
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageContent);
